import React, { useEffect, useState } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import TotalSidebar from '../components/TotalSidebar/TotalSidebar'
import CheckoutContainer from '../components/CheckoutContainer/CheckoutContainer'
import Footer from '../components/Footer/Footer'
import ProductOrderBox from '../components/ProductOrderBox/ProductOrderBox'
import PageHeader from '../components/PageHeader/PageHeader'
import { Col, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { fetchCart } from '../hook/cart'

function Checkout() {

  const dispatch=useDispatch()
  const userinfo = useSelector((state) => state);
  const [payment, setPayment] = useState('')
  const [phone, setPhone] = useState(userinfo.auth.userArray.phone)
  const [orderData, setOrderData] = useState(null);
  const cart = useSelector((state) => state.cartReducer.cart);

  const handleDataFromChild = (data) => {
    
    setOrderData(data);
  };


  useEffect(() => {
    dispatch(fetchCart());

    // const getCart = async () => {
    //   await axios
    //  .get(`https://nanosoft.technology/outlaw/api/cart`, {
    //       headers: {
    //                         Authorization: `Bearer ${userinfo?.auth?.access_token}`
    //       }
    //     })
    //     .then(async (res) => {
    //       setCart(res.data.data);

    //     })
    //     .catch((error) => {

    //       console.log(error.response.data);


    //     });
    // }
    // getCart()
  }, [])
  const handleChildData = (val) => {
    setPayment(val);

  }
  const handlePhoneData = (val) => {

    setPhone(val);

  }
  console.log(cart.items);
  

  return (
    <>
      <NavbarContainer />

      <Container className='py-5'>
        <Row>

          <Col md={8}>
            <CheckoutContainer
              sendDataToParent={handleDataFromChild}
              sendPhoneToParent={handlePhoneData}

            />
          </Col>
          <Col md={4}>
            <ProductOrderBox
              items={cart.items[0]}
            />
            <TotalSidebar
              item={cart}
              payment={payment}
              phone={phone}
              orderData={orderData}
            />


          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  )
}

export default Checkout